import { Controller } from "./helpers/controller";
import {shim} from "./helpers/shim";
import {ShowLoader} from "./utils/showLoader";

export class MemberSignupSession extends Controller {

    private timer: number | undefined;
    
    private btnForwardStandard: JQuery = $('.btnForward');
    private btnBackStandard: JQuery = $('.btnBack');
    
    private inCentre: JQuery = $('#inCentre');
    private chooseCentre: JQuery = $('[data-switch-choose-centre]');
    private selectedDetailsJson: JQuery = $('#selectedDetails');
    private selectedTypeCost: JQuery = $('#selectedCost');
    private selectedTypeFrequency: JQuery = $('#selectedFrequency');
    private selectedTypeSessionType: JQuery = $('#selectedSessionType');
    private selectedTypeSessionIds: JQuery = $('#selectedSessionIds');

    private rdoProductVariant: JQuery = $('.priceRadioOption');
    private btnMembershipCost: JQuery = $('#btnMembershipCost');
    private btnGetStarted: JQuery = $('#btnGetStartedSelection');
    private btnEditCentre: JQuery = $('[data-switch-edit-centre]');
    private btnEditProduct: JQuery = $('[data-switch-edit-tuition]');
    private btnEditMembershipType: JQuery = $('[data-switch-edit-type]');
    private btnEditSlot1: JQuery = $('[data-switch-edit-slot1]');
    private btnEditSlot2: JQuery = $('[data-switch-edit-slot2]');
    private btnEditYourDetails: JQuery = $('[data-switch-edit-your-details]');
    private btnEditChildDetails: JQuery = $('[data-switch-edit-child-details]');
    private btnEditDirectDebitDetails: JQuery = $('[data-switch-edit-ddd]');
    private addressChoiceIsSame: JQuery = $('[name="IsSameAddress"]');
    private addressTypeSelection: JQuery = $("[data-switch-child-address]");
    private txtAddressLine1: JQuery = $('[data-address="line1"]');
    private txtAddressLine2: JQuery = $('[data-address="line2"]');
    private txtAddressLine3: JQuery = $('[data-address="line3"]');
    private txtAddressTownCity: JQuery = $('[data-address="townCity"]');
    private txtAddressPostcode: JQuery = $('[data-address="postcode"]');
    
    private noGetStartedNext: JQuery = $("[data-switch-form-navigation-get-started]");
    private getStartedNext: JQuery = $("[data-switch-form-navigation-get-started-complete]");
    private rdoIsFreeTrial: JQuery = $("input[type=radio][name=IsFreeTrial]");

    private inpNumericInputs: JQuery = $('input[type=number]');

    private pageWrap: JQuery = $('.pageWrap')
    private loader: JQuery = $('#loading-spinner')

    private autocomplete: google.maps.places.Autocomplete | undefined;
    
    constructor(element: HTMLElement) {
        super(element);

        this.handleProductVariantSelected();
        this.handleAddressTypeSelected();

        this.btnForwardStandard.on('click', (e) => {
            e.preventDefault();
            this.submitMainForm();
        });
        this.btnBackStandard.on('click', (e) => {
            e.preventDefault();
            this.handleEditSelected('formBack');
        })
        this.inCentre.on('click', (e) => {
            this.chooseCentre.show();
        });
        this.btnEditCentre.on('click', (e) => {
            this.handleEditSelected('formEditLocation');
        })
        this.btnEditProduct.on('click', (e) => {
            this.handleEditSelected('formEditProduct');
        });
        this.btnEditMembershipType.on('click', (e) => {
            this.handleEditSelected('formEditMembershipType');
        });
        this.btnEditSlot1.on('click', (e) => {
            this.handleEditSelected('formEditSlot1');
        });
        this.btnEditSlot2.on('click', (e) => {
            this.handleEditSelected('formEditSlot2');
        });
        this.btnEditYourDetails.on('click', (e) => {
            this.handleEditSelected('formEditYourDetails');
        });
        this.btnEditChildDetails.on('click', (e) => {
            this.handleEditSelected('formEditChild');
        });
        this.btnEditDirectDebitDetails.on('click', (e) => {
            this.handleEditSelected('formEditDirectDebitDetails');
        });
        this.rdoIsFreeTrial.on('click', (e) => {
            this.handleGetStartedComplete();
        });
        this.btnGetStarted.on('click', (e) => {
            this.handleGetStarted();
        })
        this.rdoProductVariant.on('click', (e) => {
            this.handleProductVariantSelected();
        });
        this.addressChoiceIsSame.on('click', (e) => {
            this.handleAddressTypeSelected();
        })

        this.inpNumericInputs.on('wheel', (e) => {
            let me = $(e.currentTarget);
            me.blur()
        })

        this.loadAddressAutocomplete()
    }

    public loadAddressAutocomplete = () => {

        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            if (typeof (shim('google')) === 'undefined' || typeof (shim('google').maps) === 'undefined') {
                if (document.querySelectorAll('#google-maps-api').length <= 0) {
                    let tag = document.createElement('script');
                    tag.src = '//maps.googleapis.com/maps/api/js?key=AIzaSyAz54REQBZR3ziqLFLa92AC5L9Zr4Be4oU&libraries=places&callback=Function.prototype';
                    tag.id = 'google-maps-api';
                    let firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
                }

                this.loadAddressAutocomplete();
            } else {

                if (this.txtAddressLine1.length > 0){
                    this.autocomplete = new google.maps.places.Autocomplete(this.txtAddressLine1.get()[0] as HTMLInputElement, {
                        componentRestrictions: { country: ["uk"] },
                        fields: ["address_components", "geometry"],
                        types: ["address"],
                    });

                    this.autocomplete.addListener("place_changed", this.fillInAddress);
                }
     
            }
        }, 50);
    }
    
    fillInAddress = () => {
        if (this.autocomplete !== undefined) {
            const place = this.autocomplete.getPlace();
            let address1 = "";
            let address2 = "";
            let address3 = "";
            let townCity = "";

            let postcode = "";

            if (place.address_components !== undefined) {
                // Get each component of the address from the place details,
                // and then fill-in the corresponding field on the form.
                // place.address_components are google.maps.GeocoderAddressComponent objects
                // which are documented at http://goo.gle/3l5i5Mr
                for (const component of place.address_components) {
                    // @ts-ignore remove once typings fixed
                    const componentType = component.types[0];

                    switch (componentType) {
                        case "street_number": {
                            address1 = `${component.long_name} ${address1}`;
                            break;
                        }
                        case "route": {
                            address1 += component.long_name;
                            break;
                        }
                        case "postal_code": {
                            postcode = `${component.long_name}${postcode}`;
                            break;
                        }
                        case "postal_code_suffix": {
                            postcode = `${postcode}-${component.long_name}`;
                            break;
                        }
                        case "locality":
                            address2 = component.long_name;
                            break;
                        case "postal_town":
                            townCity = component.long_name;
                            break;
                        case "administrative_area_level_1": {
                          //  townCity = component.short_name;
                            break;
                        }
                    }
                }

                this.txtAddressLine1.val(address1);
                this.txtAddressLine2.val(address2);
                this.txtAddressLine3.val(address3);
                this.txtAddressTownCity.val(townCity);
                this.txtAddressPostcode.val(postcode);
            }
        }
    }

    submitMainForm = () => {
        let form = <HTMLFormElement>document.getElementById('formMemberSignupMain');
        let dob = $('#DateOfBirth');
        if (dob.length == 1){
            dob.val($(".DayOfBirth").val() + "/" + $(".MonthOfBirth").val() + "/" + $(".YearOfBirth").val());

        }
        
        this.submitForm(form);
    }

    handleProductVariantSelected = () => {
        if (this.btnMembershipCost.length > 0) {
            let selectedVariantCost = $('.priceRadioOption:checked').data('cost');
            let selectedVariantFrequency = $('.priceRadioOption:checked').data('frequency');
            let selectedVariantSessionType = $('.priceRadioOption:checked').data('sessiontype');
            let selectedVariantSessionIds = $('.priceRadioOption:checked').data('sessionids');
            this.selectedTypeCost.val(selectedVariantCost)
            this.selectedTypeFrequency.val(selectedVariantFrequency)
            this.selectedTypeSessionType.val(selectedVariantSessionType)
            this.selectedTypeSessionIds.val(selectedVariantSessionIds)
            this.btnMembershipCost[0].innerHTML = 'Select &pound;' + selectedVariantCost + ' &sol; month';
        }
    }

    handleEditSelected = (formId: string) => {
        let form = <HTMLFormElement>document.getElementById(formId);
        let payload = this.selectedDetailsJson.val();
        var input = $('<input>')
            .attr('type', 'hidden')
            .attr('name', 'selectedDetailsJson')
            .val(payload);
        form.append(input.get(0));
        this.submitForm(form);
    }

    handleGetStarted = () => {
        let form = <HTMLFormElement>document.getElementById('formMemberSignupGetStarted');
        if ($('input[name="IsFreeTrial"]:checked').val() === 'true') {
            form.action = form.action.replace('signup', 'trial');
        }
        this.submitForm(form);
    }

    handleAddressTypeSelected = () => {
        let selected = $("input[name='IsSameAddress']:checked");

        if (selected.length == 0) return;

        if (selected.val() === 'true') {
            this.addressTypeSelection.hide();
        } else {
            this.addressTypeSelection.show();
        }
    }


    handleGetStartedComplete = () => {
        this.noGetStartedNext.hide();
        this.getStartedNext.show();
    }

    submitForm = (form: HTMLFormElement) => {
        if (form !== null) {
            if ("useSpinner" in form.dataset) {
                ShowLoader(this.loader);
            }
            form.submit();
        }
    }
}


